import React from "react";

interface Props {
  className?: string;
}

export const AppleLogo: React.FC<Props> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.707 5.25586C15.2432 4.60547 15.6211 3.71777 15.6211 2.82129C15.6211 2.69824 15.6123 2.5752 15.5947 2.47852C14.7158 2.51367 13.6611 3.05859 13.0371 3.79688C12.5361 4.35938 12.0791 5.25586 12.0791 6.15234C12.0791 6.29297 12.1055 6.4248 12.1143 6.46875C12.167 6.47754 12.2549 6.49512 12.3516 6.49512C13.1338 6.49512 14.1182 5.96777 14.707 5.25586ZM15.3223 6.67969C14.0127 6.67969 12.9404 7.47949 12.2549 7.47949C11.5254 7.47949 10.5762 6.73242 9.43359 6.73242C7.2627 6.73242 5.06543 8.52539 5.06543 11.9004C5.06543 14.0098 5.87402 16.2334 6.88477 17.666C7.74609 18.8789 8.50195 19.8721 9.5918 19.8721C10.6641 19.8721 11.1387 19.1602 12.4746 19.1602C13.8281 19.1602 14.1357 19.8545 15.3223 19.8545C16.5 19.8545 17.2822 18.7734 18.0293 17.71C18.8555 16.4883 19.207 15.3018 19.2158 15.2402C19.1455 15.2227 16.8955 14.2998 16.8955 11.7246C16.8955 9.49219 18.6621 8.49023 18.7676 8.41113C17.5986 6.73242 15.8145 6.67969 15.3223 6.67969Z"
      fill="#FFFFFF"
    />
  </svg>
);
